import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { useMutation } from '@apollo/client';
import { RESTORE_CHARGE } from 'graphql/service';
import colors from 'constants/colors';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ModalRestoreCharge = ({
  buttonIcon,
  iconStyle,
  charge,
  setBill,
}) => {

    const [isOpen, setIsOpen] = useState(false)

    const [restoreCharge, {loading}] = useMutation(RESTORE_CHARGE, {
      onCompleted: (data) => {
        setIsOpen(false)
        setBill(data.restoreCharge)
      },
      onError: (error) => {
        debouncedErrorMessage(error.message);
      }
    })

  const handleUndo = () => {
    if(loading) return
    restoreCharge({
      variables: {
        chargeId: charge.chargeId
      },
    });
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        buttonIcon={buttonIcon}
        iconStyle={iconStyle}
        className="modal-success"
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              height: 100%;
              padding: 24px;
            }
          }
          background: ${colors.black5};
          top: 179px;
        `}
      >
        <Container>
          <div className='text'>{`Reverse deleted charge: "${charge.description}" ?`}</div>
          <div className='buttonContainer'>
            <Button
              danger
              onClick={() => setIsOpen(false)}
              additionalstyle={`
                width: 79px;
                margin-right: 16px;
              `} 
            >
              Cancel
            </Button>
            <Button
              success
              onClick={handleUndo}
              data-loading={loading}
              additionalstyle={`
                width: 70px;
              `}
            >
              {loading? null: 'Undo'}
            </Button>
          </div>
        </Container>
      </MainModal>
    </>
  );
}

export default ModalRestoreCharge;
